







































































































import { Component, Mixins, VModel, Watch } from 'vue-property-decorator'

import ModelSetter from '../../../../Mixins/ModelSetter'
import { SelectOption } from '../../../../logic/types'
import { UseFields } from '../../../Pi'
import NestedContent from '../../../Pi/components/NestedContent.vue'
import { FieldData } from "../../../Pi/types";
import { Telegram, TelegramProviderType, YookassaVatCode } from '../types'

@Component({
  components: {
    NestedContent
  }
})
export default class TelegramSetting extends Mixins<UseFields>(UseFields, ModelSetter) {
  @VModel() model!: Telegram

  get telegramProviderTypeOptions(): Array<SelectOption> {
    return Object.keys(TelegramProviderType).map(value => ({
      label: this.$t(`cash_register_telegram_provider_type_${ value.toLowerCase() }`),
      value,
    }))
  }

  get yookassaVatCodeOptions(): Array<SelectOption> {
    return [
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode1 }`), value: YookassaVatCode.VatCode1 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode2 }`), value: YookassaVatCode.VatCode2 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode3 }`), value: YookassaVatCode.VatCode3 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode4 }`), value: YookassaVatCode.VatCode4 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode5 }`), value: YookassaVatCode.VatCode5 },
      { label: this.$t(`yookassa_vat_code_option_${ YookassaVatCode.VatCode6 }`), value: YookassaVatCode.VatCode6 },
    ]
  }

  providerTypeSetter(args: FieldData) {
    args.setter = (value: keyof typeof TelegramProviderType | null) => {
      this.$set(args.model, args.key, value)

      if (value === "Yookassa") {
        this.$set(args.model, 'send_receipt', false)
      } else {
        this.$delete(args.model, 'send_receipt')
        this.$delete(args.model, 'vat_code')
      }
    }

    return args
  }

  onYookassaAddReceiptChange({ checked }: {checked: boolean}) {
    if (!checked) {
      this.$set(this.model, 'vat_code', null)
    } else {
      this.$set(this.model, 'vat_code', YookassaVatCode.VatCode1)
    }
  }
}
